export default "__VITE_ASSET__684aae17__"